module.exports = __webpack_public_path__ + "img/Cori_halo.213cfacd.png";